module.exports = __webpack_public_path__ + "static/img/big_logo.6ece7a9e.svg";